export const PillSize = {
    SMALL: "small",
    LARGE: "large"
} as const;

export type IPillSizeType = typeof PillSize;
export type PillSizeUnionType = IPillSizeType[keyof IPillSizeType];
